module.exports = __webpack_public_path__ + "img/Team.7b73764d.jpeg";